import React, { useState, useRef } from 'react';
import axios from 'axios';

const SpeechToText2 = () => {
  const [text, setText] = useState('');
  const [processedText, setProcessedText] = useState('');
  const [isListening, setIsListening] = useState(false);

  const handleListen = () => {
      // Check if the browser supports SpeechRecognition
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRecognition) {
          alert('Your browser does not support speech recognition.');
          return;
      }

      if (!isListening) {
          setIsListening(true);
          const recognition = new SpeechRecognition();
          recognition.lang = 'en-US';
          recognition.interimResults = false;
          recognition.maxAlternatives = 1;

          recognition.onresult = async (event) => {
              const speechToText = event.results[0][0].transcript;
              setText(speechToText);
              setIsListening(false);

              try {
                  const response = await axios.post('http://localhost:5000/api/voice-to-text', { text: speechToText });
                  setProcessedText(response.data.processedText);
              } catch (error) {
                  console.error('Error processing text:', error);
              }
          };

          recognition.onerror = (event) => {
              console.error('Speech recognition error', event);
              setIsListening(false);
          };

          recognition.start();
      }
  };
  return (
    <div>
       <header className="App-header">
                <h1>Live Voice to Text</h1>
                <button onClick={handleListen}>
                    {isListening ? 'Listening...' : 'Start Listening'}
                </button>
                <p><strong>Original Text:</strong> {text}</p>
                <p><strong>Processed Text:</strong> {processedText}</p>
            </header>
    </div>
  );
};

export default SpeechToText2;
